<template>
  <div class="content">
    <headerNav leftNav=" " :title="navTitle" @leftClick="back"></headerNav>
    <main class="content-main">
      <!-- 步骤条 -->
      <TaskProgress
        :perform="{ taskGoalCount: taskPlanObj.superiorsTask, percentageRate: Number(taskPlanObj.superiorsAccomplishRate) || 0 }"
        :percentageMoney="taskPlanObj.practicalAccomplish"
        :unit="routerData.termSlug == 'transfer_output' || routerData.termSlug == 'supply_output' ? '万' : '个'" />
      <div class="content-center-title">
        <img src="@/assets/task-management/task-details-center-title.png" alt="">
        <div>市场详情</div>
      </div>

      <!-- table -->
      <el-table :data="marketTableData" style="width: 100%" v-if="marketTableData.length > 0"
        header-cell-class-name="market-title" row-class-name="market-row" row-key="marketCode"
        :expand-row-keys="defaultExpandList">
        <!-- 自定义暂无数据 -->
        <template slot="empty">
          <div class="empty-no-data">
            <img src="../../../../assets/task-management/no-data.png" alt="">
            <div>暂无数据</div>
          </div>
        </template>
        <el-table-column type="index" label="TOP" align="center" width="43">
          <template slot-scope="props">
            <div v-if="props.$index < 3" style="line-height: 1;"><img class="index-img" :src="getImageIndex(props.$index)"
                alt=""></div>
            <div v-else> {{ props.$index + 1 }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="marketName" label="市场" min-width="44">
          <template slot-scope="props">
            <!-- 判断是线索量还是其他 -->
            <span v-if="routerData.termSlug == 'clue_count'" class="market-content-text">{{ props.row.marketName }}</span>
            <span v-else class="market-content-a" @click="onClickMarketDetails(props.row)">{{ props.row.marketName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="transferProductionValue" :label="outputCount.transferProductionValue" align="right"
          min-width="85">
        </el-table-column>
        <el-table-column prop="taskProductionValue" :label="outputCount.taskProductionValue" align="right" min-width="85">
        </el-table-column>
        <el-table-column prop="accomplishRate" label="完成率" align="right" min-width="67">
          <template slot-scope="scope">
            <span class="complete" v-if="scope.row.accomplishRate">{{ scope.row.accomplishRate && scope.row.accomplishRate
              != '-' ?
              scope.row.accomplishRate + '%' : scope.row.accomplishRate
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="handle" label="操作" min-width="38">
          <template slot-scope="scope">
            <span class="market-details" @click="expandControlRow(scope.row)">详情</span>
          </template>
        </el-table-column>
        <!-- 展开行详情 -->
        <el-table-column type="expand" width="1">
          <template slot-scope="scope">
            <div class="market-content-expand">
              <div class="market-content-expand-left">
                <img src="@/assets/task-management/task-details-table-expand.png" alt="">
                <div>上月任务：{{ scope.row.lastMonthProductionValue }}{{ routerData.termSlug == 'transfer_output' ||
                  routerData.termSlug == 'supply_output' ? '万元' : '个' }}</div>
              </div>
              <div class="market-content-expand-right">
                <span class="color-green" v-if="scope.row.isSuccess == '1'">已完成</span>
                <span class="color-red" v-else>未完成</span>
              </div>
            </div>
            <div class="market-content-expand-row"
              v-if="(scope.row.taskProductionValue == '-' || scope.row.taskProductionValue == '0' || scope.row.taskProductionValue == '0.00') && routerData.roleCode == 'ROLE_603933' && (routerData.termSlug == 'transfer_output' || routerData.termSlug == 'supply_output')">
              <div class="market-content-expand-seting" @click="setTask(scope.row)">
                <img src="@/assets/task-management/task-details-table-seting.png" alt="">
                <div>任务设置</div>
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </main>

    <!-- 任务设置 -->
    <van-dialog v-model="setTaskDialogVisible" :showConfirmButton="false" @close="setTaskDialogClose">
      <div class="set-task-dialog">
        <!-- 导航 -->
        <div class="set-task-dialog-nav">
          任务设置
          <div class="set-task-dialog-nav-close" @click="closeSetTaskDialog">×</div>
        </div>
        <!--内容  -->
        <div class="set-task-dialog-mian">
          <van-form @submit="onSubmitTask">
            <van-field v-model="taskDialogFrom.value" name="任务产值" label-width="80px" label="任务产值:" placeholder="请输入任务产值"
              :rules="[{ required: true }]" type="digit">
              <i slot="left-icon" style="color:red">*</i>
              <template #button>{{ routerData.termSlug == 'transfer_output' ||
                routerData.termSlug == 'supply_output' ? '万' : '个' }}</template>
            </van-field>
            <div class="set-task-dialog-foot">
              <van-button class="btn" round block type="info" native-type="submit"
                :loading="submitLoading">确认</van-button>
            </div>
          </van-form>

        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import TaskProgress from "@/components/task-management/task-progress.vue"
import estimateOutput from "../../component/data.js"
import api from "@/api/task-management/board.js";
import { Toast } from "vant";

export default {
  components: {
    TaskProgress
  },
  data () {
    return {
      // 任务看板路由接参
      routerData: {},
      // 市场表格数据
      marketTableData: [],
      // 展开行id
      defaultExpandList: [],
      // 任务设置弹窗
      setTaskDialogVisible: false,
      taskDialogFrom: {
        value: ''
      },
      // 表头动态展示内容
      outputCount: {},
      // 顶部任务产值目标
      taskPlanObj: {},
      setRowsData: {},
      submitLoading: false
    }
  },
  created () {
    let localData = JSON.parse(localStorage.getItem('TABLE_HEADER_CONTENT'))
    this.routerData = localData
    this.getTableData()
    this.outputCount = estimateOutput(localData.termSlug)
    this.navTitle = this.outputCount.transferProductionValue.slice(0, 4) + '详情'
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    // 查询表格数据
    async getTableData () {
      try {
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        const { data } = await api.taskDetailApi({ ext: this.routerData.termSlug, Q_reportData_EQ: this.routerData.Q_reportData_EQ, type: '1' })
        this.taskPlanObj = data.accomplishCondition ? data.accomplishCondition : {}
        this.marketTableData = data.data01
      } finally {
        Toast.clear()
      }
    },
    // 控制展开行
    expandControlRow (item) {
      const position = this.defaultExpandList.indexOf(item.marketCode)
      if (position !== -1) {
        this.defaultExpandList.splice(position, 1)
      } else {
        this.defaultExpandList.push(item.marketCode)
      }
    },
    // 获取图片
    getImageIndex (index) {
      return require(`@/assets/task-management/task-details-table-${index + 1}.png`)
    },
    // 任务设置
    setTask (row) {
      this.setRowsData = row
      this.setTaskDialogVisible = true
    },
    // 确定
    async onSubmitTask () {
      try {
        this.submitLoading = true
        let obj = {
          id: this.taskPlanObj.taskParentId,
          taskDate: this.routerData.Q_reportData_EQ,
          termId: this.routerData.termSlug,
          marketCode: this.setRowsData.marketCode,
          taskType: 'D',
          productionMinValue: 0,
          productionGoalValue: 0,
          productionJobValue: this.taskDialogFrom.value,
          operateType: '1'
        }
        const data = await api.setTasksMarketApi(obj)
        if (data.code == 200) {
          this.getTableData()
          Toast('设置成功')
        } else {
          Toast(data.msg)
        }
      } finally {
        this.setTaskDialogVisible = false
        this.submitLoading = false
      }
    },
    // 关闭
    closeSetTaskDialog () {
      this.setTaskDialogVisible = false
    },
    setTaskDialogClose () {
      this.taskDialogFrom = {
        value: ''
      }
    },
    // 点击市场查看部门
    onClickMarketDetails (row) {
      localStorage.setItem('MARKET_DATA', JSON.stringify(row))
      let userInfo = JSON.parse(localStorage.getItem('TABLE_HEADER_CONTENT'))
      let routerName = ''
      if (userInfo.termSlug == 'transfer_output' || userInfo.termSlug == 'supply_output' || userInfo.termSlug == 'transfer_count' || userInfo.termSlug == 'supply_count') {
        // 转单产值，补齐产值、转单量、补齐量--查看督导详情和转单详情的部门列表
        routerName = 'department-list'
      } else {
        // 签单量到店量--查看单独的部门列表
        routerName = 'department-alone-list'
      }
      this.$router.push({ path: `/task-management/board/${routerName}` })
    }
  }
}
</script>

<style lang="scss" scoped>
.content ::v-deep {
  .el-table__expand-icon>.el-icon {
    display: none;
  }

  .empty-no-data {
    img {
      width: 160px;
      height: 150px;
    }

    div {
      color: #5E5E5E;
      font-size: 18px;
      margin-top: -40px;
    }
  }

  .content-main {
    background: #F5F5F5;
    height: calc(100vh - 50px);
    overflow: auto;
    margin-top: -1px;

    .content-center-title {
      height: 47px;
      line-height: 47px;
      display: flex;
      align-items: center;
      background: #fff;
      padding: 0px 10px;
      margin-top: 16px;

      img {
        width: 24px;
        height: 24px;
      }

      div {
        color: #333333;
        font-size: 18px;
        font-family: PingFang SC-Bold, PingFang SC;
        font-weight: 550;
      }
    }

    .complete {
      white-space: nowrap;
      overflow: hidden;
    }

    .market-title {
      background-color: #F5F5F5;
      color: #1D2129;
      font-size: 13px;
      font-family: PingFang SC-Bold, PingFang SC;
      padding: 0px 0px;

      .cell {
        padding: 10px 3px;
        font-size: 13px;
        font-weight: 500;
      }
    }

    .market-row {
      font-size: 16px;
      color: #1D2129;

      .el-table__cell {
        padding: 3px 0px;
        height: 30px;
      }

      .cell {
        padding: 5px 3px;
        font-weight: 400;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }

    .el-table__expand-colum {
      visibility: hidden;
    }

    .el-table__body-wrapper {
      height: calc(100vh - 150px);
      overflow: auto;
    }

    .market-details {
      color: #0E8BFF;
      font-size: 13px;
    }

    .market-content-a {
      color: #0E8BFF;
      font-size: 13px;
      font-weight: 400;
    }

    .market-content-text {
      font-size: 13px;
      font-weight: 400;
    }

    .index-img {
      width: 20px;
      height: 20px;
    }

    .market-content-expand {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 11px 16px;
      // border-bottom: 1px solid #F1F1F1;

      .market-content-expand-left {
        display: flex;
        align-items: center;

        img {
          width: 20px;
          height: 20px;
        }

        div {
          color: #545454;
          font-size: 15px;
          margin-left: 10px;
        }
      }

      .market-content-expand-right {
        width: 46px;
        height: 22px;
        line-height: 22px;
        font-size: 13px;
        text-align: center;
        font-weight: bold;
        font-family: PingFang SC-Bold, PingFang SC;

        span {
          padding: 2px 3px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: visible;
          font-weight: 500;
          border-radius: 4px;

        }

        .color-red {
          color: #FF6157;
          background: #FAEBEA;
        }

        .color-green {
          color: #17CA5E;
          background: #E3F5EA;
        }
      }
    }


    .market-content-expand-row {
      display: flex;
      justify-content: end;
      margin: 0px 11px 4px;
      padding-top: 12px;
      border-top: 1px solid #F1F1F1;

      .market-content-expand-seting {
        display: flex;
        align-items: center;
        width: 91px;
        height: 28px;
        line-height: 28px;
        border: 1px solid #3DA2FF;
        color: #0E8BFF;
        font-size: 18px;
        border-radius: 4px;
        padding-left: 6px;
        box-sizing: border-box;
        cursor: pointer;
        user-select: none;

        img {
          width: 18px;
          height: 18px;
          margin: 1px 2px 0px 0;
        }
      }
    }


  }

  .set-task-dialog {
    .set-task-dialog-nav {
      text-align: center;
      margin: 12px 0px;
      padding: 0 17px 12px 17px;
      font-weight: bold;
      color: #424242;
      font-size: 16px;
      border-bottom: 1px solid #DFDFDF;

      .set-task-dialog-nav-close {
        float: right;
        font-size: 15px;
      }
    }

    .set-task-dialog-mian {
      padding: 16px 0 0;

      .van-field__body {
        border-bottom: 1px solid #BEBEBE;
      }

      .van-field__label {
        margin-right: 0;
        color: #252523;
        font-size: 16px;
      }

      .van-cell::after {
        border: 0;
      }

      .set-task-dialog-foot {
        // width: 100%;
        text-align: center;
        padding: 0px 14px 18px 15px;
        margin-top: 16px;

        .btn {
          border-radius: 4px;
          // width: 290px;
          // height: 44px;
          background: #3975C6;
        }
      }
    }
  }
}
</style>